module.exports = __webpack_public_path__ + "img/icon_image_share.797437b5.png";